module.exports = __webpack_public_path__ + "e72834f8fee05693a208590ebbab23fa.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/widget-icons/cancel.png
// module id = 3026
// module chunks = 0